export default "__VITE_ASSET__vQ8bY13M__"